import { motion } from 'framer-motion';
import React from 'react';

import { cn } from './cn';

export interface FilterBarProps {
  className?: string;
  children?: React.ReactNode;
}

export const FilterBar = ({ className, children }: FilterBarProps) => {
  return (
    <motion.fieldset
      className={cn('flex items-center gap-2.5 border-none p-0 m-0', className)}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
    >
      <legend className="sr-only">Filter by</legend>
      {children}
    </motion.fieldset>
  );
};
